<template>
    <div class="modal fade" id="modal_reset_password" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestUser" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('auth.login.reset_password') }}

                    </h5>
                    <button @click="closeModal('modal_reset_password', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestResetPassword">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestResetPassword.email" :label="i18n.t('auth.reset.email')"
                                :v="v$.email" :disabled="false" />
                        </div>
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestResetPassword.password" :label="i18n.t('auth.reset.password')"
                                :v="v$.password" :disabled="false" />
                        </div>
                        <div class="form-group mr-b-0em">

                            <inputText v-model="requestResetPassword.password_confirmation"
                                :label="i18n.t('auth.reset.password_confirmation')" :v="v$.password_confirmation"
                                :disabled="false" />
                        </div>
                        <div class="row">


                            <div class="col-md-6 text-right">

                                <button type="button" @click="closeModal('modal_reset_password', 'add')"
                                    class="w-100 btn btn-cancel">
                                    {{ i18n.t('button.close') }}
                                </button>
                            </div>
                            <div class="col-md-6 text-right">
                                <button type="submit" class="w-100 btn btn-primary mr-2">
                                    {{ i18n.t('button.reset_password') }}
                                </button>
                            </div>


                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">

import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import { defineComponent, ref, computed, watch, watchEffect, toRefs } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import MultipSelect from "@/components/inputsValidation/MultipSelect.vue";
import inputTextarea from "@/components/inputsValidation/ReusableTextarea.vue";
import Status from '@/components/status.vue';

/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { useUser } from "@/composables/auth/useUser";
import { useClub } from '@/composables/club/useClub';
import { user, userUUID, clubUUID } from "@/shared/state";
import { ResetPasswordRequest } from "@/interfaces/user";

import { useVuelidate } from "@vuelidate/core";
import { required, helpers, requiredIf, minLength, email, numeric, maxLength, maxValue, minValue } from "@vuelidate/validators";

export default defineComponent({
    components: {
        inputText
    },
    name: "component-inscription",
    props: {
        user: {
            type: Object,
            default: null,
        },
    },
    setup(props) {
        const APP_URL = process.env.VUE_APP_URL;
        const { user } = toRefs(props);
        const { closeModal } = useModal();
        const requestResetPassword = ref<ResetPasswordRequest>({
            email: null,
            password: null,
            password_confirmation: null,
            userUUID: null
        });

        watch(
            () => user.value,
            (newValue) => {
                requestResetPassword.value.email = user?.value?.email ?? null
                requestResetPassword.value.userUUID = user?.value?.uuid ?? null
            });


        const currentUser = computed(() => user.value);
        const { resetPassword, isRequestUser } = useUser();

        // Validation 
        const rules = {
            email: {
                required: helpers.withMessage(i18n.t("validator.required"), required), email,

            },
            password: {
                required: helpers.withMessage(i18n.t("validator.required"), required), String

            },
            password_confirmation: {
                required: helpers.withMessage(i18n.t("validator.required"), required),
                String
            }

        };
        const v$ = useVuelidate(rules, requestResetPassword, { $scope: 'user' });

        /**
         * edit or edit member
         */
        const submitForm = () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                resetPassword(requestResetPassword.value).then((res) => {
                    console.log(res)
                    if (res) {
                        emptyState()
                        closeModal('modal_reset_password', 'add')
                    }
                })

            }
        }
        const emptyState = () => {
            // requestResetPassword.value.userUUID = null
            // requestResetPassword.value.email = null
            requestResetPassword.value.password = null
            requestResetPassword.value.password_confirmation = null
            v$.value.$reset();
        };




        return {
            /**
             * States
             */
            currentUser,
            requestResetPassword,
            submitForm,
            emptyState,
            v$,
            i18n,
            APP_URL,
            closeModal,
            isRequestUser
        };
    },
});
</script>

<style lang="scss"></style>